/*
 * @Description: 文件描述
 * @Author: lxx
 * @Date: 2024-09-12 14:32:08
 * @FilePath: /BackpackBattle/assets/boot/scripts/LoadingCache.ts
 */

export enum SceneId {
    /** 游戏可交互(首个场景)	 */
    S1 = "S1",
    /** 加载Bundle之Game */
    S2 = "S2",
    /** 加载loading场景 */
    S3 = "S3",
    /** 进入加载场景 */
    S4 = "S4",
    /**  加载完成,进入游戏里 */
    S5 = "S5",
}


const TTSceneId = {
    /** 游戏可交互(首个场景)	 */
    S1: 7001,
    /** 加载Bundle之Game */
    S2: 1004939,
    /** 加载loading场景 */
    S3: 1004940,
    /** 进入加载场景 */
    S4: 1004941,
    /**  加载完成,进入游戏里 */
    S5: 1004946,
}

const WXSceneId = {
    /** 游戏可交互(首个场景)	 */
    S1: 7,
    /** 加载Bundle之Game */
    S2: 1001,
    /** 加载loading场景 */
    S3: 1002,
    /** 进入加载场景 */
    S4: 1003,
    /**  加载完成,进入游戏里 */
    S5: 1004,
}

class LoadingCache {

    private _loadingTime1: number;
    public get loadingTime1(): number {
        return this._loadingTime1;
    }
    public set loadingTime1(v: number) {
        this._loadingTime1 = v;
    }


    /**
     * 上报加载时长,关注抖音性能变化 
     * @param { number } sceneId 抖音相关场景值
     * @param { number } costTime 场景耗时，单位ms​
     */
    public reportScene(sceneId: SceneId, costTime: number) {
        switch (cc.sys.platform) {
            case cc.sys.BYTEDANCE_GAME:
            case cc.sys.BYTEDANCE_GAME_SUB: {
                tt.reportScene && tt.reportScene({
                    sceneId: TTSceneId[sceneId], // 抖音自定义场景分析
                    costTime: costTime, // 场景耗时，单位ms​
                })
                break;
            }
            case cc.sys.WECHAT_GAME:
            case cc.sys.WECHAT_GAME_SUB: {
                wx.reportScene && wx.reportScene({
                    sceneId: WXSceneId[sceneId], // 抖音自定义场景分析
                    costTime: costTime, // 场景耗时，单位ms​
                })
                break;
            }

        }

    }


    /** 加载Bundle */
    loadBundle(bundleName: string, cb: (costTime: number) => void) {
        let startTime: number = Date.now();
        cc.assetManager.loadBundle(
            bundleName,
            () => {
                console.log(`bundleName: ${bundleName} [${(Date.now() - startTime) / 1000}]加载完成`)
                cb && cb(Date.now() - startTime);
            }
        );
    }

}

export const loadingCache = new LoadingCache();
